var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"touchstart":function () {}}},[_c('Nav'),_c('router-view'),_c('MobileFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }